import { Component, Input, OnInit } from '@angular/core';
import { AppInjector } from '@carm/_utils/app.injector';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'carm-index-page-section',
  templateUrl: './index-page-section.component.html',
  styleUrls: ['./index-page-section.component.scss'],
})
export class IndexPageSectionComponent implements OnInit {

  @Input()
  inPath: string;

  @Input() isClient: boolean;

  @Input()
  inLocalizedTitle: string;

  @Input()
  inLocalizedDescription: string;

  @Input()
  inDataCy: string;

  @Input()
  requestSource: string;

  @Input()
  isPublic: boolean;

  inPathChanged = false;
  protected translateService: TranslateService;

  constructor() {
    const injector = AppInjector.getInjector();
    this.translateService = injector.get(TranslateService);
  }

  ngOnInit(): void {
    if (this.inPath === "/customs-brokers") {
      this.inPath = this.translateService.instant('application_features.homepage.sections.brokers.brokersLink');
      this.inPathChanged = true;
    }
  }
}
